var map = {
	"./ageas.png": "4c79",
	"./allianz.png": "8cea",
	"./amtrust.png": "a73f",
	"./arc-assistance.png": "683c",
	"./arc.png": "cc4d",
	"./arkel.png": "b74a",
	"./aviva.png": "7b33",
	"./axa.png": "ab93",
	"./bspoke.png": "4e88",
	"./covea.png": "60e8",
	"./geo.png": "c191",
	"./integra.png": "1912",
	"./lg.png": "d8c4",
	"./lv.png": "4887",
	"./prestige.png": "fa96",
	"./property-guard.png": "abf5",
	"./rsa.png": "d105",
	"./tradex.png": "82ff",
	"./ukg.png": "e89a",
	"./unknown.png": "f3ac",
	"./zurich.png": "51b4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c9b";